import { CALL_API } from '../middleware/api'

export const OCCUPANCY_REQUEST = 'OCCUPANCY_REQUEST'
export const OCCUPANCY_SUCCESS = 'OCCUPANCY_SUCCESS'
export const OCCUPANCY_FAILURE = 'OCCUPANCY_FAILURE'

// Live occupancy aggregate (counts per status/zone/type/machine).
// customer: only honored server-side for ADMIN users.
// zone: Contract.Zone number, optional.
export function fetchOccupancy(customer, zone) {
  let params = ''

  if (customer !== undefined && customer !== '') {
    params += `&customer=${customer}`
  }

  if (zone !== undefined && zone !== '') {
    params += `&zone=${zone}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `matrixs/occupancy?${params}`,
      authenticated: true,
      types: [OCCUPANCY_REQUEST, OCCUPANCY_SUCCESS, OCCUPANCY_FAILURE]
    }
  }
}
